<template>
	<div class="msg_box clearfloat">
		<div></div>
		<div class="schedule_box">
			<div class="schedule_one">
				<span>1</span>我的购物车
			</div>
			<div class="schedule_two">
				<span>2</span>确认订单信息
			</div>
			<div class="schedule_three">
				<span>3</span>成功提交订单
			</div>
		</div>
		<div class="order_to">
			<span><input type="checkbox" name="vehicle" value="Car" @click="handleSelectAll" v-model="allChecked" />全选</span>
			<span>货号</span>
			<span>商品名称</span>
			<span>规格</span>
			<span>单价</span>
			<span>商品数量</span>
			<span>总价</span>
			<span>操作</span>
		</div>
		<div v-loading="loading" class="min_he400">
			<div v-if="shoppingList.length" class="chopping_box">
				<div  class="chopping_zi" v-for="(itme,i) in shoppingList" :key="itme.id">
					<div class="chopping_li">
						<input type="checkbox" name="vehicle" value="Car" @click="select(itme.id)" v-model="itme.ismode" />
					</div>
					<div class="chopping_li">
						{{itme.goods_model}}
					</div>
					<div class="chopping_li chopping_goods clearfloat">
						<img class="flo_lf" @click="xin.goUrl('/products/'+itme.goods_id)" :src="itme.goods_images" />
						<div class="flo_lf asdmoi">
							<div class="itemitle" @click="xin.goUrl('/products/'+itme.goods_id)">{{itme.goods_name}}</div>
							<div class="lan" v-if="itme.category" @click="xin.goUrl('/oneDetails?cid='+itme.category.id)">{{itme.category.title}}</div>
						</div>
					</div>
					<div class="chopping_li">
						{{itme.sku_value}}
					</div>
					<div class="chopping_li">
						¥{{itme.sku_sale_price}}
					</div>
					<div class="chopping_li">
						<!-- <div class="goods_input_int">
							<button v-notClick="isTosub" :class="{'cur_not':itme.number==1}" class="cur_po" @click="handleChange(itme,-1)">-</button>
							<div>{{itme.number}}</div>
							<button v-notClick="isTosub" class="cur_po" @click="handleChange(itme,1)">+</button>
						</div> :class="{'cur_not':itme.number==itme.goods_stock}"-->
						
						 <el-input-number @input="setNumber(itme)" size="small" @change="handleChange(itme.number,itme.sku_id,itme.goods_id)"
						:min="1" :max="999" :precision="0" v-model="itme.number"></el-input-number>
					</div>
					<div class="chopping_li">
						¥{{itme.sku_sale_price * itme.number |tofi}}
					</div>
					<div class="chopping_li">
						<button class="lan" @click="deleSho(i)">删除</button>
					</div>
				</div>
			</div>
			<div v-else class="gwcko">
				<p>空空如也!</p>
			</div>
		</div>
		<div class="chopping_di">
			<div class="flo_lf asddsa ">
				<input type="checkbox" name="vehicle" value="Car" @click="handleSelectAll" v-model="allChecked" />全选
				<span class="redf" @click="deleAll">删除</span>
			</div>
			<div class="flo_right czx">
				<button v-notClick="isTosub" @click="close" class="laing_btn flo_right ">
					去结算
				</button>
				<div class="flo_right">
					<span>免运费</span>
					商品金额:
					<span class="jing">￥{{totalPrice}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapActions} from 'vuex'
	export default {
		data() {
			return {
				loading:true,
				isTosub:true,
				totalNum: 0, //总数量
				totalPrice: 0, //总价格
				allChecked: false, //是否全选
				shoppingList: [],//购物车列
			}
		},
		filters:{
		},
		created(){
			this.PostGoodsList();
			this.setgoodsCount();
		},
		mounted(){
			// let dom = document.getElementsByClassName('el-input__inner');
			// dom[dom.length-1].setAttribute('disabled', 'disabled')
		},
		methods: {
			...mapActions(['setgoodsCount']),
			setNumber(item){
				if(!item.number){
					item.number = ' ';
				}
			},
			close(){
				if(this.totalNum){
					this.isTosub = false;
					let goods =[];
					this.shoppingList.forEach((v,i)=>{
						if(v.ismode)
							goods.push({sku_id:v.sku_id,number:v.number});
					})
					// /order
					this.$router.push({name:'确认订单',params:{
						goods,
						is_cart:1
					}})
					this.isTosub = true;
				}else
					this.$message({ message: '至少勾选一产品', type: 'warning' });
			},
			async PostGoodsList(){//获取购物车列表
				this.loading=true;
				let {data} = await this.api.PostGoodsList();
				data.goods.forEach(v=>v.ismode = false);
				this.shoppingList = data.goods;
				this.conut(data.goods);
				this.loading = false;
			},
			async deleSho(i){//删除单个
				this.$confirm('是否删除该产品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(async() => {
						let {data,code} = await this.api.PostGoodsrm({skus:this.shoppingList[i].sku_id})
						if(code==200){
							this.$message({message: '删除成功!', type: 'success' });
							this.shoppingList.splice(i,1);
							this.setgoodsCount();
						}
					}).catch(() => {

					});
			},
			async deleAll(){//删除选中的产品
				let skus='';
				let shoppingList = this.shoppingList;
				shoppingList.forEach(v=>{
					if(v.ismode)skus+=v.sku_id+",";
				})
				if(skus)
				this.$confirm('是否删除选中的产品', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(async() => {
						let {data,code} = await this.api.PostGoodsrm({skus})
						if(code==200){
							this.$message({message: '删除成功!', type: 'success' });
							this.PostGoodsList();
							this.setgoodsCount();
						}
					}).catch(() => {

					});
			},
			handleSelectAll(){//全选/反选
			  let {shoppingList,allChecked} = this;
			  shoppingList.forEach(v=>{
			    v.ismode = !allChecked;
			  })
			  this.conut(shoppingList);
			},
			async handleChange(number,sku_id,goods_id){//商品数量加减
				this.isTosub = false;
				let {code} = await this.api.PostGoodupdate({sku_id,goods_id,number});
				if(code==200){
					this.conut(this.shoppingList);
				}
				this.isTosub = true;
			},
			select(id){//商品选择
				let { shoppingList } = this;
				let index = shoppingList.findIndex(v => v.id == id);
				shoppingList[index].ismode = !shoppingList[index].ismode;
				this.conut(shoppingList);
			},
			conut(cartlist) {//计算价格
				this.allChecked = cartlist.length ? cartlist.every(v => v.ismode) : false;
				let totalNum = 0;
				let totalPrice = 0;
				cartlist.forEach(v => {
					//如果商品列表中的元素是选中的
					if (v.ismode) {
						totalNum += v.number; //数量的统计
						if(v.spce_type==2){
							totalPrice += v.sku_sale_price * v.number;
						}else
							totalPrice += v.goods_sale_price * v.number; //价格统计
					}
				})
				this.totalPrice = totalPrice.toFixed(2);
				this.totalNum = totalNum;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
.gwcko{
	height: 400px;
	text-align: center;
	line-height: 400px;
	font-size: 24px;
}
	.redf {
		cursor: pointer;
		color: #b03130;
		margin: 0 5px;
	}

	.chopping_di {
		margin-top: 40px;

		.asddsa {
			margin-left: 40px;
		}

		.laing_btn {
			width: 210px;
			height: 40px;
			line-height: 40px;
		}

		.czx {
			line-height: 40px;
		}

		.flo_right {
			margin: 0 10px;
		}

		
	}

	input[type="checkbox"] {
		// display: none;
		width: 16px;
		height: 16px;
	}

	.msg_box {

		.chopping_box {
			.chopping_zi {
				display: flex;
				align-items: center;
				padding: 30px 0;
				height: 100px;
				border-bottom: 1px solid #D9D9D9;

				.chopping_li {
					/deep/ input{
						
					}
				}

				&>div {
					flex: 1;
					text-align: center;
				}

				.chopping_goods {
					flex: 3;
					text-align: left;
					.asdmoi {
						height: 75px;
						margin-left: 20px;
						& :nth-child(1){
							overflow:hidden;
							text-overflow:ellipsis;
							display:-webkit-box;
							-webkit-box-orient:vertical;
							-webkit-line-clamp:2;
							width: 	200px;
							
						}
						.lan{
							margin-top: 30px;
						}
					}

					img {
						cursor: pointer;
						width: 100px;
						height: 75px;
					}
				}
			}
		}


		.order_to {
			margin-top: 30px;
			color: #fff;
			height: 40px;
			background: #005599;
			display: flex;
			align-items: center;

			span:nth-child(3) {
				flex: 3;
				text-align: center;
			}

			span:not(:nth-child(3)) {
				flex: 1;
				text-align: center;
			}
		}
	}




	.schedule_box {
		.schedule_one {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_1.png) no-repeat 100% 100%;
			color: #fff;
		}
		.schedule_two {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_2.png) no-repeat 100% 100%;
			background-size: 100% 100%;
			color: #333;
		}
		.schedule_three {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_3.png) no-repeat 100% 100%;
			color: #333;
		}
	}
</style>
